import Dialog from "../../../Components/ConfirmDialog";
import lang from "../../../asset/Language.json";
import React from "react";
import {StaticDatePicker} from "@mui/lab";
import LeavingService from "../../../services/LeavingService";

export default function CheckIn(props) {
    const {  setOpenCheckin, onChange, open } = props;
    const [saveChanges, setSaveChanges] = React.useState(false);
    const [date, setDate] = React.useState(null);
   

    // Calculate the first day of the previous month
    const getFirstDayOfLastMonth = () => {
        const today = new Date();
        const currentMonth = today.getMonth();
        const currentYear = today.getFullYear();

        // If current month is January (0), go to December (11) of previous year
        const lastMonth = currentMonth === 0 ? 11 : currentMonth - 1;
        const yearOfLastMonth = currentMonth === 0 ? currentYear - 1 : currentYear;

        return new Date(yearOfLastMonth, lastMonth, 1);
    };

    const minDate = getFirstDayOfLastMonth();
    const onMyChange = (value) => {
        setDate(value);
        setSaveChanges(true);
    }

    
    
    // Function to disable weekends (Saturday and Sunday)
    const isWeekend = (date) => {
        const day = date.getDay();
        return day === 0 || day === 6; // 0 is Sunday, 6 is Saturday
    };
    
    const onMonthChanged = async (date) => {
        const month = date.getMonth();
        const year = date.getFullYear();
        const fromDate1 = new Date(year, month,1,0,0,1).toISOString();
        const toDate1 = new Date(year, month + 1,0,23,59,59).toISOString();
        const leaveService = new LeavingService();
        const leaves = await leaveService.getLeaveDays({
            fromDate: fromDate1,
            toDate: toDate1,
            userId: 0
        });
    }
    
    const content =  <React.Fragment>
        <StaticDatePicker 
            view={"day"} 
            value={date} 
            onChange= { value => onMyChange(value)} 
            disableCloseOnSelect={true} 
            disableOpenPicker={true} 
            disableFuture={true} 
            showToolbar={false} 
            shouldDisableDate={isWeekend}
            minDate={minDate}
        />
    </React.Fragment>
    
    return <Dialog
        className="dialog-a-visible check-in-calendar"
        okText ={lang.lotrinh.checkin}
        cancelText={lang.buttons.boqua}
        disabledYes={!saveChanges}
        open={open}
        onYes={evt => onChange(date)}
        onClose={evt => setOpenCheckin(false)}
        msgContent={content}
        
    />
}